<template>
<div class="login-container" v-if="loaded">
  <div class="login-inputs login-form" style="margin-top:13em;">
    <form v-if="!reset_code && !is_forgot_password" @submit.prevent="login">
    <div class="m-b-30 header">{{$t(greetingMessage())}}<br>{{$t('welcome')}}</div>
      <div>
        <InputText
          class="login-input"
          placeholder="Email"
          label="Email"
          v-model="email"
        />
      </div>
      <div>
        <InputText
          class="login-input"
          placeholder="Password"
          type="password"
          :label="$t('password')"
          v-model="password"
          :link="`${$t('forgot_password')}`"
          @linkAction="is_forgot_password = !is_forgot_password"
          v-on:keyup.enter.native="login"
        />
      </div>
      <div class="login-buttons">
      <Btn
        class="brand login-button"
        :btnText="$t('sign_in')"
        @btnClick="login"/>
      </div>
    </form>
    <form v-else-if="!reset_code && is_forgot_password" @submit.prevent="forgotPassword">
     <div class="m-b-30 header">{{$t('reset_your_password_here')}}</div>
      <div>
        <InputText
          class="login-input"
          placeholder="Email"
          label="Email"
          v-model="forgot_password_email"
        />
      </div>
      <div class="login-buttons">
        <Btn
          class="brand login-button"
          :btnText="$t('Reset password')"
          @btnClick="forgotPassword"/>
      </div>
      <a  href="#" @click="is_forgot_password = !is_forgot_password">
      {{$t('back_to_login')}}
      </a>
    </form>
    <form v-else-if="reset_code" class="login small-width" @submit.prevent="resetPassword">
      <div>
        <InputText
          class="login-input"
          type="password"
          :label="$t('enter_new_password')"
          v-model="reset_password"
        />
        <InputText
          class="login-input"
          type="password"
          :label="$t('confirm_your_password')"
          v-model="reset_password_confirmation"
        />
      </div>
      <Btn
        class="brand d-inline-block m-r-20"
        :icon="{
          name: 'check',
          size: '22',
          color: '#fff',
        }"
        :btnText="$t('Reset Password')"
        @btnClick="resetPassword"/>
      <a href="#" @click="reset_code = ''">{{$t('back_to_login')}}</a>
    </form>
  </div>
  <div class="login-image-container">
    <img v-if="computeHeroImage" class="img" :src="computeHeroImage" alt="login">
    <img v-else class="img" src="../assets/images/login-background.png" alt="login">
  </div>
</div>
</template>
<script>
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import { mapGetters } from 'vuex';
/* eslint-disable */
export default {
  name: 'Login',
  components: {Btn, InputText},
  data() {
    return {
      loaded: false,
      is_forgot_password: false,
      email: process.env.VUE_APP_EMAIL,
      password: process.env.VUE_APP_PASSWORD,
      redirectRoute: this.$route.query.from || process.env.VUE_APP_DEFAULT_PAGE,
      forgot_password_email: '',
      reset_code: '',
      reset_password: '',
      reset_password_confirmation: '',
      loginSettings: {}
    };
  },
  computed: {
    ...mapGetters([
      'get_admin_settings'
    ]),
    computeHeroImage() {
      if (this.loginSettings.admin_login_image) {
        return this.loginSettings.admin_login_image
      }
      return false;
    }
  },
  created() {
    this.reset_code = this.$route.query.code;
    this.$store.dispatch('GET_ADMIN_SETTINGS', window.location.hostname).then((r) => {
      this.loginSettings = this.get_admin_settings

      if(this.loginSettings.admin_custom_style) {
        const head = document.head || document.getElementsByTagName('head')[0]
        const style = document.createElement('style')

        head.appendChild(style);
        style.appendChild(document.createTextNode(this.loginSettings.admin_custom_style));
      }
    }).finally(() => setTimeout( () => this.loaded = true, 50));
  },
  methods: {
    login() {
      if (this.email === '' && this.password === '') {
        return;
      } else {
        this.$store.dispatch('LOGIN', {
          email: this.email,
          password: this.password
        }).then((loginRes) => {
          // STORE TOKEN
          this.$store.dispatch('STORE_TOKEN', loginRes.token).then(() => {
          // GET AND SOTRE USER
            this.$store.dispatch('GET_PROFILE').then((profileRes) => {
              this.$store.dispatch('STORE_USER', profileRes);
              this.$store.dispatch('GET_USER_PERMISSIONS', {id: profileRes.id}).then(() => {
                this.$store.dispatch('GET_SUBACCOUNTS').then((response) => {
                  if(profileRes.active_subaccount_id != null){
                    this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.id == profileRes.active_subaccount_id)[0]);
                    localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.id == profileRes.active_subaccount_id)[0]));
                  } else {
                    this.$store.dispatch('STORE_ACTIVE_SUBACCOUNT', response.filter((item) => item.is_main == 1 )[0]);
                    localStorage.setItem('subaccount',  JSON.stringify(response.filter((item) => item.is_main == 1 )[0]));
                  }
                  localStorage.userId = profileRes.id
                  this.$store.dispatch('LOGIN_USER_FLAG', true);
                  this.$router.push(this.redirectRoute);
                })
              });
            });
          });
        });
      }
    },
    checkPermission(permissions) {
      let result = false;
      this.get_user_permissions.forEach((perm) => {
        if(perm.acl_route_group == permission) result = perm.view;
      })
      return result;
    },
    forgotPassword() {
      this.$store.dispatch('FORGOT_PASSWORD', {email: this.forgot_password_email})
        .then(() => {
          // on status OK do nothing.
          // User will go to the email and click on the reset password link.
          alert('Success, check your email for the reset password link.')
        });
    },
    resetPassword() {
      this.$store.dispatch('RESET_PASSWORD', {
        code: this.reset_code,
        password: this.reset_password,
        confirm_password: this.reset_password_confirmation,
      }).then(() => {
        // on status OK show login form.
        alert('Success, now you can login with your new password')
        this.reset_code = ''
        this.$router.push('/login')
      });
    },
    greetingMessage(){
      const today = new Date();
      const h = today.getHours();
      if (h>=5 && h<12){
        return 'good_morning';
      }else if (h>=12 && h<17 ){
        return 'good_afternoon';
      }else {
        return 'good_evening';
      }
    },
  }
};
</script>
